<template>
  <div class="getPassword">
    <login-header v-bind="headerInfo"></login-header>
    <div class="content">
      <div class="zc-tit">修改密码</div>
      <div class="zc-box zh-box">
        <ul class="dl-list">
          <li class="clearfix login-input">

            <input type="password" class="input" placeholder="请输入原密码" v-model="oldPass" id="mobile2" name="oldPass">
          </li>
          <li class="clearfix login-input">

            <input type="password" class="input" placeholder="请输入新密码" v-model="newPass" ref="verificationCode">
          </li>

          <li class="clearfix login-input">

            <input type="password" class="input" placeholder="确认新密码" v-model="confirmPass">
          </li>
        </ul>
        <div class="protocol clearfix"></div>
        <div class="btn-box">
          <button class="yellow-btn" @click="editPass">确认修改</button>
          <button class=" yellow-btn gray-btn" @click="goBack">返回</button>
        </div>

      </div>
    </div>

    <login-footer :description="desc"></login-footer>
  </div>
</template>

<script>
import loginHeader from '../header'
import loginFooter from '../footer'
import qs from 'qs'

var sec2 = 60 // 计时器时间
var clockName2 = 'smsClock' // 计时器名称
var _method2 = 'sms'

export default {
  name: 'get-password',
  components: {
    loginHeader,
    loginFooter
  },
  data() {
    return {
      headerInfo: {
        type: '修改密码',
        userDisplayFlag: false,
        userName: '',
        logo: ''
      },
      desc: '',
      userInfo: {},
      disVal: '',
      socialization: 0,
      captchaObj: {},
      oldPass: '',
      newPass: '',
      confirmPass: '',
      backUrl: '',
      isClick: true
    }
  },
  created() {
    document.title = localStorage.getItem('title')
    this.loginInfo = qs.parse(localStorage.getItem('xdata'))
    this.headerInfo.logo = this.loginInfo.logo
    this.desc = this.loginInfo.desc
    this.socialization = this.loginInfo.is_master
    document.getElementsByTagName('title')[0].innerHTML = this.loginInfo.name
    var _backUrl = this.getUrlParam('backUrl')
    if (_backUrl) {
      this.backUrl = decodeURIComponent(_backUrl)
    }
  },
  mounted() {
    this.initGee()
  },
  methods: {
    getUrlParam(name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)') // 构造一个含有目标参数的正则表达式对象
      var r = window.location.search.substr(1).match(reg) // 匹配目标参数
      if (r != null) return decodeURI(r[2])
      return null // 返回参数值
    },
    initGee() {
      var that = this
      QM.apinew({
        url: '/seller/account/start-gt',
        method: 'get',
        success: function(data) {
          initGeetest(
            {
              gt: data.data.gt,
              challenge: data.data.challenge,
              product: 'popup', // 产品形式，包括：float，embed，popup。注意只对PC版验证码有效
              offline: !data.data.success // 表示用户后台检测极验服务器是否宕机，一般不需要关注
            },
            that.handlerPopup
          )
        },
        error: function(data) {}
      })
    },

    // 返回
    goBack() {
      if (this.backUrl) window.location.href = this.backUrl
      else this.$router.back()
    },

    // 退出登录
    exitLogin() {
      var that = this
      QM.apinew({
        url: '/seller/user/logout',
        method: 'post',
        data: {},
        success: function(xdata) {
          that.$router.push({ path: '/login.html' })
        },
        error: function(xdata) {
          that.$message.error(xdata.message)
        }
      })
    },
    //    修改密码
    editPass() {
      var that = this

      if (!this.isClick) {
        return
      }

      if (!that.oldPass) {
        that.$message.error('请填写原密码！')
        return
      }
      if (!that.newPass) {
        that.$message.error('请填写新密码！')
        return
      }
      if (!that.confirmPass) {
        that.$message.error('请填写确认新密码！')
        return
      }
      if (that.newPass != that.confirmPass) {
        that.$message.error('两次输入密码不一致')
        return
      }
      this.isClick = false
      QM.apinew({
        url: '/seller/user/set-password',
        method: 'post',
        data: {
          password: that.oldPass,
          new_password: that.newPass
        },
        success: function(xdata) {
          that.$message({
            message: '密码修改成功，请重新登录',
            type: 'success',
            duration: 1500
          })

          setTimeout(() => {
            that.isClick = true
            that.$message.close()
            that.exitLogin()
          }, 1500)
        },
        error: function(xdata) {
          that.isClick = true
          that.$message.error(xdata.message)
        }
      })
    }
  }
}
</script>

<style scoped>
.yellow-btn:hover {
  background: #f7dd68;
}
.gray-btn {
  background: #f7f7f7;
  color: #333;
}
.gray-btn:hover {
  background: #f7f7f7;
}
.btn-box {
  display: flex;
}
.btn-box .yellow-btn {
  width: 500px;
}
.btn-box .gray-btn {
  width: 200px;
  margin-left: 10px;
}
.login-input{
  height: 62px;
  overflow: hidden;
}
</style>